import Funnel from "../../services/funnel-service.js";

const template = `
    <div v-show="fs.display(input)" role="alert" aria-live="assertive">
        <small :id="input.id" :class="input.small_class">{{input.text}}</small>
    </div>
`;

export default {
    name: 'b-inline-error-text',
    template,
    props: ['iuid'],
    computed: {
        fs: function () {
            return new Funnel({ ctx: this.$store, router: this.$router });
        },
        input: function () {
            return this.$store.getters.funnel.elements[this.iuid];
        }
    },
    methods: {}
};